import storageFallback from './storage-fallback';

const { sessionStorage } = window;

export const setItem = (key: string, value: string): void => (sessionStorage || storageFallback).setItem(key, value);
export const getItem = (key: string): string | undefined | null => (sessionStorage || storageFallback).getItem(key);
export const removeItem = (key: string): void => (sessionStorage || storageFallback).removeItem(key);
